import { useReducer } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.min.css";
import { toast, ToastContainer } from "react-toastify";
import FormReducer from "@utils/FormReducer";
import ActionButton from "./formInputs/buttons/ActionButton";

const Login = (): JSX.Element => {
    const navigate = useNavigate();

    const initialFormState = {
        username: ""
    };

    const [formState, formDispatch] = useReducer(FormReducer, initialFormState);

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { name, value } = e.target;
        formDispatch({
            type: "text",
            field: name,
            payload: value
        });
    };

    const handleSubmit = (): void => {
        const username = formState.username as string;
        if (username?.trim().length) {
            sessionStorage.clear();
            sessionStorage.setItem("devLogin", "devLogin");
            navigate(`/loadtest/${username.trim()}`);
        } else {
            toast.error("Please enter a valid Username.");
        }
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                width: "80%",
                margin: "0 auto",
                background: "#D3D3D3"
            }}
        >
            <ToastContainer />
            <div
                style={{
                    width: "100%",
                    margin: "0 auto",
                    marginBottom: "50px",
                    marginTop: "50px",
                    textAlign: "center"
                }}
            >
                <h2>Welcome to the EngagED Parent Portal!</h2>
                <p>Please Enter a Username Below</p>
                <div style={{ marginTop: "50px", width: "100%" }}>
                    <label htmlFor="username">
                        Username:{" "}
                        <input
                            className="form-control"
                            id="username"
                            name="username"
                            onChange={handleOnChange}
                            type="text"
                        />
                    </label>
                </div>
                <div className="m-5" />
                <ActionButton className="action-button-reg" label="Log In" onClick={handleSubmit} />
            </div>
        </div>
    );
};

export default Login;
